<table mat-table [dataSource]="tableData" matSort class="mat-elevation-z8">

  @for (col of tableParams; track col) {
    <ng-container matColumnDef="{{col.variable_name}}">
      <th mat-header-cell *matHeaderCellDef> {{col.column_name}} </th>
      <td mat-cell *matCellDef="let element"> {{element[col.variable_name]}} </td>
    </ng-container>
  }

  @if (showHeader) {
    <span><tr mat-header-row *matHeaderRowDef="displayedColumns"></tr></span>
  }
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
